module.exports = __webpack_public_path__ + "img/card8.ac4e8cc6.jpg";